/* src/app/components/planestratamiento/planform/planform.component.scss */
/*# sourceMappingURL=planform.component.css.map */
